/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class encounterindex extends IceEntity {
  encounter_index_key: string = "";
  encounter_key: string = "";
  appointment_key: string = "";
  patient_trans_account: string = "";
  trans_account: string = "";
  account_type = IceTypes.ACCOUNT_TYPE.actNone;
  appointment_status = IceTypes.appt_status.apptstatNone;
  appointment_type = IceTypes.appt_type.appttypeInitial;
  time_slot_start: any = NaN;
  time_slot_end: any = NaN;
  last_name: string = "";
  phone: string = "";
  provider_keywords: string = "";
  merged_trans_account: string = "";
  patient_room_num: string = "";
  patient_bed_num: string = "";
  patient_case_key: string = "";
  rto_type: number = 0;
  signature: boolean = false;
  doctor_signature: boolean = false;

  gettablename(): string {
    return "ENCOUNTER_INDEX";
  }
}
